module.exports = __webpack_public_path__ + "media/images/crypto-currencies/nem-073154d269f1f2adae356a03e7c95855.svg";